import { useEffect, useState } from 'react';
import { Card, Table, Button, Badge, Alert, Spinner } from 'react-bootstrap';
import { api } from '../api/client';
import { formatDateTime } from '../shared/dateFormat';

const STATUS_BADGE = {
  demo_scheduled: 'warning',
  demo_completed: 'info',
  hired: 'success',
  rejected: 'secondary',
  cancelled: 'secondary',
};

export default function TeacherDemos() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const load = async () => {
    setLoading(true);
    try { setRows(await api.get('/teacher/demos')); }
    catch (e) { setMsg({ type: 'danger', text: e.message }); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const complete = async (id) => {
    if (!window.confirm('Mark this demo as completed?')) return;
    try {
      await api.post(`/teacher/demos/${id}/complete`);
      setMsg({ type: 'success', text: 'Demo marked complete. Student can now hire or reject.' });
      await load();
    } catch (e) { setMsg({ type: 'danger', text: e.message }); }
  };

  if (loading) return <div className="text-center py-5"><Spinner /></div>;

  return (
    <>
      <h3 className="mb-4">Demo Requests</h3>
      {msg.text && <Alert variant={msg.type} dismissible onClose={() => setMsg({ type: '', text: '' })}>{msg.text}</Alert>}
      {rows.length === 0 ? (
        <Alert variant="info">No demo requests yet.</Alert>
      ) : (
        <Table bordered hover responsive className="bg-white">
          <thead className="table-dark"><tr><th>Student</th><th>Phone</th><th>Grade</th><th>City</th><th>Slot</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {rows.map((d) => (
              <tr key={d.id}>
                <td>{d.student_name}</td>
                <td>{d.phone || '-'}</td>
                <td>{d.grade || '-'}</td>
                <td>{d.city || '-'}</td>
                <td>{formatDateTime(d.demo_slot_at)}</td>
                <td><Badge bg={STATUS_BADGE[d.status] || 'secondary'}>{d.status.replace('_', ' ')}</Badge></td>
                <td>
                  {d.status === 'demo_scheduled' && (
                    <Button size="sm" variant="primary" onClick={() => complete(d.id)}>Mark complete</Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}
